module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hexagon item-color",
    class: [_vm.isSelected ? 'item-selected' : ''],
    on: {
      "click": function($event) {
        return _vm.itemsSelect(_vm.index)
      }
    }
  }, [_c('div', {
    staticClass: "subj-name"
  }, [_vm._v(_vm._s(_vm.title))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8f9e9d38","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subject/item.vue
// module id = 1627
// module chunks = 0